export default ({
  elClassName = "",
  otherClasses = [],
  lightboxDialogClassName = "lightbox-dialogue",
  containerClassName = "",
  closeBtnClass = ".lightbox__close",
  dynamic = true
}: {
  elClassName?: string;
  otherClasses?: string[];
  lightboxDialogClassName?: string;
  containerClassName?: string;
  closeBtnClass?: string;
  dynamic?: Boolean;
}) => {
  let lb = document.createElement("div");
  const body: HTMLBodyElement | HTMLElement | null = document.querySelector(
    containerClassName ? containerClassName : "body"
  );

  if (dynamic) {
    lb.innerHTML = `
      <div class="lightbox-container container">
        <div class="lightbox__close"></div>
        <div class="${lightboxDialogClassName}"></div>
      </div>
    `;
  } else {
    // @ts-ignore
    lb = document.querySelector(containerClassName) || document.body;
  }

  const closeBtn = lb.querySelector(closeBtnClass);

  if (closeBtn !== null && body !== null) {
    closeBtn.addEventListener("click", () => {
      lb.classList.add("hide");
      document.body.style.overflow = "unset";
      document.body.classList.remove("lightbox-active");

      if (elClassName == "sign-up") {
        // enable scroll on the body
        document.body.style.height = "auto";
        document.body.style.overflow = "auto";
        document.body.style.position = "unset";
      }
    });
  }

  if (containerClassName != "body") {
    lb.classList.add("lightbox", "hide", elClassName, ...otherClasses);
  }

  lb.addEventListener("click", (e: any) => {
    if (e.target === e.currentTarget) {
      lb.classList.add("hide");
      // @ts-ignore
      body.style.overflow = "auto";
      // @ts-ignore
      body.classList.remove("lightbox-active");
    }
  });

  if (dynamic && lb !== null && body !== null) {
    body.appendChild(lb);
  }
};

export const open = ({
  func,
  className,
  containerClassName
}: {
  func?: Function;
  className: string;
  containerClassName: string;
}) => {
  const lb: HTMLElement | null = document.querySelector(`.${className}`);
  const body: HTMLBodyElement | null = document.querySelector(
    containerClassName ? containerClassName : "body"
  );

  if (lb !== null && body !== null) {
    lb.classList.remove("hide");
    body.style.overflow = "hidden";
    body.classList.add("lightbox-active");

    if (className == "sign-up") {
      // disabled scroll on the body
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    }

    if (func !== undefined) {
      func();
    }
  }
};
